import {gql} from '@apollo/client';

export default gql`
  mutation downloadAd($input: DownloadAdInput!) {
    authed {
      success
    }
    downloadAd(input: $input) {
      success
    }
  }
`;
